// extracted by mini-css-extract-plugin
module.exports = {"canvas":"canvas_canvas__vYU1O"};